import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import APIList, { APIListWrapper } from '../components/APIList'
import LabelOnly from '../components/LabelOnly'
import DownLoadIcon from '../asset/DownLoadIcon'
import DeleteIcon from '../asset/DeleteIcon'
import { useLazyQuery, useQuery } from '@apollo/client'
import {
  findAllKepcoTOUGQL,
  findOneKepcoTOUGQL,
} from '../gql/PurchasePlans.gql'
import TOUHeatMap from '../components/graph/TOUHeatMap'
import {
  KepcoChargeUnitData,
  KepcoChargeUnitTable,
} from '../components/KepcoChargeUnitTable'

interface ButtonProps {
  active?: boolean
}

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  background-color: #fff;
  overflow: hidden;
`

const Header = styled.div`
  padding: 16px 24px 16px 24px;
  background: #373a40;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-shrink: 0;
`

const Title = styled.div`
  font-family: SUIT;
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: left;
  color: #ffffff;
`

const Body = styled.div`
  display: flex;
  padding: 24px;
  gap: 40px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  background-color: #fff;
`

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 50%;
`

const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const RightBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0px 0px 10px;
  gap: 16px;
`

const HeatMapWrapper = styled.div`
  height: 550px;
  width: 500px;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
  gap: 12px;
`

const Bottom = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
`

const ButtonBox = styled.div`
  display: flex;
  padding: 8px;
  border-radius: 4px;
  gap: 4px;
  align-items: center;
  cursor: pointer;
`

const ButtonText = styled.div`
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`

// 버튼 컴포넌트 생성
const Button = styled.button<ButtonProps>`
  padding: 10px 20px;
  margin: 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  outline: none;
  background-color: ${(props) => (props.active ? '#007bff' : '#f0f0f0')};
  color: ${(props) => (props.active ? '#fff' : '#000')};
`

export const DataKepco = () => {
  const { data: originKepcoList } = useQuery(findAllKepcoTOUGQL)
  const [KepcoList, setKepcoList] = useState<any[]>()
  const [selected, setSelected] = useState()

  const [selectedType, setSelectedType] = useState<string>()
  const [filteredKepco, setFilteredKepco] = useState<KepcoChargeUnitData[]>([])
  // 한전요금제
  const [kepcoData, setKepcoData] = useState<any>()
  const [findKepcoData] = useLazyQuery(findOneKepcoTOUGQL)

  const [touPeriodsData, setTouPeriodsData] = useState<any>()

  useEffect(() => {
    //@ts-ignore
    if (originKepcoList) setKepcoList(Object.values(originKepcoList)[0])
  }, [originKepcoList])

  useEffect(() => {
    if (KepcoList && KepcoList?.[0] !== '') {
      findKepcoData({
        variables: {
          val: selected,
        },
      }).then((result: any) => {
        //@ts-ignore
        if (result.data) {
          const kepcoTOU = Object.values(result.data)[0] as any
          setKepcoData(kepcoTOU.data)
          setTouPeriodsData(kepcoTOU.kepcoTOUPeriod?.touPeriods)
        }
      })
    }
  }, [selected])

  useEffect(() => {
    if (kepcoData) {
      if (selectedType == '') {
        setFilteredKepco([])
      }
      const filteredData = kepcoData.filter(
        (item: any) =>
          item.name.substring(0, 3) === selectedType?.substring(0, 3)
      )
      setFilteredKepco(filteredData)
    }
  }, [selectedType, kepcoData])

  return (
    <>
      <APIListWrapper>
        <APIList
          noApi
          dataList={KepcoList && KepcoList?.map((v: any) => v.name)}
          setSelected={setSelected}
          noFile
        />
      </APIListWrapper>
      <ContentWrapper>
        <Header>
          <Title>한전 요금제</Title>
        </Header>
        <Body>
          <Left>
            <Wrapper>
              <Button
                active={selectedType === '일반용'}
                onClick={() => {
                  if (selectedType !== '일반용') {
                    setSelectedType('일반용')
                  } else {
                    setSelectedType('')
                  }
                }}
              >
                일반용
              </Button>
              <Button
                active={selectedType === '산업용'}
                onClick={() => {
                  if (selectedType !== '산업용') {
                    setSelectedType('산업용')
                  } else {
                    setSelectedType('')
                  }
                }}
              >
                산업용
              </Button>
              <Button
                active={selectedType === '전기차'}
                onClick={() => {
                  if (selectedType !== '전기차') {
                    setSelectedType('전기차')
                  } else {
                    setSelectedType('')
                  }
                }}
              >
                전기차
              </Button>
            </Wrapper>
            {filteredKepco.map((item) => (
              <KepcoChargeUnitTable
                key={item.name}
                data={item}
                label={item.name}
              />
            ))}
          </Left>
          <Right>
            <LabelOnly label="계절별 시간대 구분" />
            <RightBody>
              <HeatMapWrapper>
                <TOUHeatMap
                  width="100%"
                  height="130px"
                  title="봄"
                  data={touPeriodsData?.spr}
                />
                <TOUHeatMap
                  width="100%"
                  height="130px"
                  title="여름"
                  data={touPeriodsData?.sum}
                />
                <TOUHeatMap
                  width="100%"
                  height="130px"
                  title="가을"
                  data={touPeriodsData?.fall}
                />
                <TOUHeatMap
                  width="100%"
                  height="130px"
                  title="겨울"
                  data={touPeriodsData?.win}
                  showLegend
                />
              </HeatMapWrapper>
              <Bottom>
                {/* <ButtonBox>
                  <DownLoadIcon />
                  <ButtonText>다운로드</ButtonText>
                </ButtonBox>
                <ButtonBox>
                  <DeleteIcon />
                  <ButtonText>삭제</ButtonText>
                </ButtonBox> */}
              </Bottom>
            </RightBody>
          </Right>
        </Body>
      </ContentWrapper>
    </>
  )
}
